import React, {useCallback, useMemo} from 'react';
import {Grid} from "@mui/material";
import {filterByOptions, sortByFields} from "./data";
import SortFilter from "../../../../components/SortFilter/SortFilter";
import EquipmentTypes from "../../../../components/EquipmentTypes";

const LocationBuyerBookedSortFilter = ({onChange}) => {

  const filterBySelectOptionsMemo = useMemo(() => {
    const equipmentTypes = EquipmentTypes.OPTIONS.map(name => ({label: name, value: name}));
    return [
      {
        label: "Equipment Type",
        value: "",
        name: "equipmentType",
        option: [{label: "All", value: ""}, ...equipmentTypes]
      }
    ];
  }, []);

  const filterByOptionsMemo = useMemo(() => {
    return filterByOptions.map((option) => {
      return {...option, value: '' };
    });
  }, []);

  const handleCallback = useCallback((e) => {
    onChange({
      city: e.filters.find(filter => filter.name === "city")?.value || '',
      state: e.filters.find(filter => filter.name === "state")?.value || '',
      equipmentType: e.selectFilters.find(filter => filter.name === "equipmentType")?.value || '',
      sortBy: e.sortBy,
      sortDir: e.sortDir,
    });
  }, [onChange]);

  return <Grid item mb={4} className={'w-100'}>
    <SortFilter
      filterCallback={handleCallback}
      sortByOption={sortByFields}
      defaultSortBy={sortByFields[0].value}
      filterByOption={filterByOptionsMemo}
      filterBySelectOption={filterBySelectOptionsMemo}
      sortDir={"asc"}
    />
  </Grid>
};

export default LocationBuyerBookedSortFilter;
